module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.detailsSizeGrid,
      "withBody": true,
      "withFooter": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('span', [_c('strong', [_vm._v("ID: ")]), _vm._v(_vm._s(this.sizeGrid.code))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Conta: ")]), _vm._v(_vm._s(this.sizeGrid.account))])]), _vm._v(" "), _c('div', [_c('span', [_c('strong', [_vm._v("Domínio: ")]), _vm._v(_vm._s(this.sizeGrid.domain))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Gênero: ")]), _vm._v(_vm._s(this.sizeGrid.gender.name))])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn btn--danger",
    on: {
      "click": function($event) {
        return _vm.openDeleteModal()
      }
    }
  }, [_vm._v("Apagar")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12c819b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/sizeGrid/Card.vue
// module id = 2921
// module chunks = 0